import { apiFetch } from "./client";
import type { UserPublic } from "./types";

export async function login(email: string, password: string): Promise<UserPublic> {
  return apiFetch<UserPublic>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export async function refresh(): Promise<UserPublic> {
  return apiFetch<UserPublic>("/auth/refresh", { method: "POST" });
}

export async function logout(): Promise<void> {
  return apiFetch<void>("/auth/logout", { method: "POST" });
}

export async function me(): Promise<UserPublic> {
  return apiFetch<UserPublic>("/auth/me");
}

export interface ProfileUpdateInput {
  full_name?: string;
  avatar_url?: string | null;
  preferred_locale?: string;
  timezone?: string;
  idle_timeout_minutes?: number | null;
}

export async function updateProfile(data: ProfileUpdateInput): Promise<UserPublic> {
  return apiFetch<UserPublic>("/auth/profile", {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function changePassword(
  current_password: string,
  new_password: string,
): Promise<void> {
  return apiFetch<void>("/auth/password/change", {
    method: "POST",
    body: JSON.stringify({ current_password, new_password }),
  });
}
